"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPresent = void 0;
// User-defined type guard, useful for refining non-nullables when using Array.filter()
// See: https://github.com/Microsoft/TypeScript/issues/16069
const isPresent = (input) => input !== null && input !== undefined;
exports.isPresent = isPresent;
